import { getCloudflareContext } from "@opennextjs/cloudflare";

export type RuntimeEnv = {
  DIRECTUS_URL?: string;
  DIRECTUS_STATIC_TOKEN?: string;
  SITE_URL?: string;
  REVALIDATE_SECRET?: string;
  LLMS_GENERATE_AUTH_TOKEN?: string;
  R2_IMAGE_BUCKET_NAME?: string;
  KV_ACCOUNT_ID?: string;
  KV_ACCOUNT_API_TOKEN?: string;
  KLAVIYO_PV_API_KEY?: string;
  KLAVIYO_MAIN_LIST_ID?: string;
  [key: string]: unknown;
};

export function getRuntimeEnv(): RuntimeEnv {
  try {
    // Available during dev and on Workers via OpenNext Cloudflare
    const ctx = getCloudflareContext();
    return (ctx?.env ?? {}) as RuntimeEnv;
  } catch {
    return (process.env as unknown as RuntimeEnv) || {};
  }
}


